<template>
 <div>
        <div class="col-md-12">
            <div class="card abtg__default-card abtg__default-card-border">
                <div class="card-head">
                    <header> </header>
                </div>
                <div class="card-body ">

<h4>Ultimi account creati</h4>
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>Ultimi 30 gg</th>
                            <th>Aste Annuale  </th>
                            <th>Mercato Annuale  </th>
                            <th>Completo Annuale  </th>
                            <th>Life  </th>
                            <th>Annual </th>
                            <th>Monthly  </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="p in content.packListData.packList">
                            <td>{{p.day}}</td>
                            <td>{{p.auction_annual}}</td>
                            <td>{{p.market_annual}}</td>
                            <td>{{p.complete_annual}}</td>

                            <td>{{p.life}}</td>
                            <td>{{p.annual}}</td>
                            <td>{{p.monthly}}</td>
                        </tr>
                        </tbody>
                    </table>


                </div>
                <div class="card-footer">
                    <div class="float-right">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'


    export default {
        mixins: [mixin],
        props: ['content'],
        components: { },
        data: function () {
            return {
            }
        },

        computed: {

        },
        created: function () {
        },
        methods: {
        }
    }
</script>
